var scope_0 = require('/bin/staticsites/ss-oryx/app-int/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6a8fcd1ed8b7ad2fe90af8e66c8eb31.js').default;
var scope_1 = require('/bin/staticsites/ss-oryx/app-int/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    